export default "6f0eea2b55378865.png"